// YOUR IDEA — the third of the welcome's three choices on the setup surface
// (components/OnboardingWizard.js; functions/onboardingPresets.js; wt/presets
// CONTRACT §1): one optional sentence that becomes an app built by the
// workspace's app builder (`/add-app`, the idea waiting in the builder's park —
// never in the URL) once the welcome ends.

// YOUR IDEA — one optional sentence for the app builder (the field: Enter
// goes on, a new line is a space), three examples that fill it, and one line
// on what happens next. With no sentence the foot's forward word is Skip.
export const OnboardingIdeaStep = {
  extends: 'OnboardingWizardStep',
  wizardStep: 'idea',

  AppTextarea: {
    name: 'onboardingIdea',
    rows: '2',
    maxlength: '200',
    autocomplete: 'off',
    enterkeyhint: 'next',
    ariaLabel: (el) => el.call('polyglot', 'workspace.onboarding.idea.label'),
    placeholder: (el) => el.call('polyglot', 'workspace.onboarding.idea.placeholder'),
    valueDeps: [(el, s) => s.root && s.root._onboardingFlow],
    value: (el, s) => {
      const flow = (s.root && s.root._onboardingFlow) || {}
      return (flow.picks && flow.picks.idea) || ''
    },
    onInput: (e, el) => el.call('onboardingIdeaSet', (e.target && e.target.value) || ''),
    onKeydown: (e, el) => {
      if (e.key !== 'Enter' || e.shiftKey || e.isComposing) return
      e.preventDefault()
      e.stopPropagation()
      el.call('onboardingWizardGo', 1)
    }
  },

  IdeaExamples: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'Y',
    minWidth: '0',
    AppMicroLabel: { text: '{{ workspace.onboarding.idea.examples | polyglot }}' },
    IdeaChips: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 'Y',
      minWidth: '0',
      childExtends: 'OnboardingIdeaChip',
      childrenAs: 'state',
      children: (el) => el.call('onboardingIdeaExamples') || []
    }
  },

  IdeaNote: {
    tag: 'p',
    margin: '0',
    fontSize: 'Z',
    lineHeight: '1.5',
    color: 'inactive',
    text: '{{ workspace.onboarding.idea.note | polyglot }}'
  }
}

// An example of an idea — the tonal capsule; a press fills the field with its
// sentence, in the session language (the person can still change it).
export const OnboardingIdeaChip = {
  extends: 'AppCapsuleBtnToolbar',
  compact: true,
  onClick: (e, el, s) => {
    e.stopPropagation()
    if (s && s.label) el.call('onboardingIdeaSet', el.call('polyglot', s.label))
  },
  ChipLabel: {
    tag: 'span',
    text: (el, s) => el.call('polyglot', (s && s.label) || '')
  }
}
